
import { defineComponent, computed } from "vue";
import VueSlider from "vue-slider-component";
import "@/styles/slider.css";
import useStore from "@/composables/useStore";
import { useI18n } from "vue-i18n";

export default defineComponent({
    name: "ClaritySelect",
    components: {
        VueSlider
    },
    setup() {
        const store = useStore();

        const { t, n } = useI18n();

        const data = [
            "I3",
            "I2",
            "I1",
            "SI2",
            "SI1",
            "VS2",
            "VS1",
            "VVS2",
            "VVS1",
            "IF",
            "FL"
        ];

        const value = computed({
            get() {
                return store.state.userSelection.clarity ?? "SI1";
            },

            set(value: string | null) {
                store.actions.setClarity(value);
            }
        });

        function tooltipFormatter(value: string) {
            return t(`diamondProperties.clarity.${value}`);
        }

        return {
            t,
            data,
            value,
            tooltipFormatter
        };
    }
});
